"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackOrderDetailsClick = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackOrderDetailsClick() {
    const eventData = {
        eventName: enums_1.GA4EventName.ClickButton,
        feature_category: enums_1.GA4FeatureCategory.CustomerAccount,
        click_element: 'Order overview show details',
        click_text: 'Details anzeigen',
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.CustomerAccount,
        eventAction: enums_1.ClickEventType.BUTTON_CLICK,
        eventLabel: 'Orders Details',
        eventValue: undefined,
        nonInteraction: false,
        eventData,
    });
}
exports.trackOrderDetailsClick = trackOrderDetailsClick;
//# sourceMappingURL=trackOrderDetailsClick.js.map